export default __webpack_public_path__ + "73f9d6c47d882b2143445c26383e0809.png";